import { Grid } from '@mui/material';
import { FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useMutateCluster } from 'pages/complementar/cluster/hooks';
import { Cluster } from 'pages/complementar/cluster/types';

export function ClusterFormComp() {
    const { handleSubmit } = useMutateCluster();

    const validationSchema = Yup.object({
        cdClusterLoja: Yup.string().required(),
        dsClusterLoja: Yup.string().required(),
    });

    return (
        <FormPage
            fgAtivo
            goBackButton
            title="Cluster"
            url="/gestao/clusterloja"
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            validateOnSubmit={true}
            validateOnChange={false}
            values={{}}
        >
            {({ values, setFieldValue, errors }: FormikProps<Cluster>) => (
                <Block>
                    <Row>
                        <Grid sx={{ flex: 1 }}>
                            <CissTextField
                                label="Código"
                                value={values.cdClusterLoja}
                                error={errors.cdClusterLoja}
                                onChange={(e) => setFieldValue('cdClusterLoja', e.target.value)}
                            />
                        </Grid>

                        <Grid sx={{ flex: 1 }}>
                            <CissTextField
                                label="Descrição"
                                value={values.dsClusterLoja}
                                error={errors.dsClusterLoja}
                                onChange={(e) => setFieldValue('dsClusterLoja', e.target.value)}
                            />
                        </Grid>
                    </Row>
                </Block>
            )}
        </FormPage>
    );
}
